import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getVisualizations } from '../../../bundles/visualizations';
import {
  getVisualizationsPanelAdminSchema,
  visualizationsPanelOptionsUiSchema,
} from '../../panels/VisualizationsPanel';
import JsonEditor from '../../JsonEditor';

const VisualizationsSettings = ({ settings, onSave, onFullSettings, onClose }) => {
  const includedVisualizations = settings?.visualizations;
  const visualizations = useSelector(getVisualizations);
  const isExtraSmallHeight = settings?.height === 'extra-small';
  const tabGroups = settings?.tabGroups || [];
  const showTabs = settings?.showTabs !== false;

  const vizNames = new Set(visualizations.map((v) => v.name));
  const updateNames = includedVisualizations?.filter((name) => vizNames.has(name));

  const updatedSettings = { ...settings, visualizations: updateNames };

  const schema = useMemo(
    () =>
      getVisualizationsPanelAdminSchema(visualizations, isExtraSmallHeight, tabGroups, showTabs),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(visualizations), isExtraSmallHeight, JSON.stringify(tabGroups), showTabs]
  );

  return (
    <div className="column-content">
      <JsonEditor
        title="Visualizations: Options"
        schema={schema}
        uiSchema={visualizationsPanelOptionsUiSchema}
        formData={updatedSettings}
        onFormSubmit={onSave}
        onSecondaryAction={onFullSettings}
        cancelCallback={onClose}
        saveButtonText={'Save'}
        initialEditMode
        showEditButton={false}
      />
    </div>
  );
};

export default VisualizationsSettings;
